import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;
import 'lazysizes';

import 'js-cloudimage-responsive';
import Flickity from 'flickity';

export const cloudImageConfig = {
	token: 'agwpcykpmo',
	domain: 'cloudimg.io',
	lazyLoading: true,
	imgLoadingAnimation: false,
    ImageSizeAttributes: 'take-ratio',
    presets: {
        xs: '(max-width: 599px)',
        sm: '(min-width: 600px)',
        md: '(min-width: 768px)',
        lg: '(min-width: 992px)',
        xl: '(min-width: 1280px)',
        xxl: '(min-width: 1440px)',
    }
};

new window.CIResponsive({...cloudImageConfig, domain: 'cloudimg.io/v7'});

const resizeFlickityInstances = (target) => {
	const parentCarousel = $(target).closest('.carousel');
	if (parentCarousel.length > 0) {
		if (parentCarousel.data('imagesLoadedListenerAttached')) {
			return;
		}

		parentCarousel.find('img').each(function (elem) {
			window.lazySizes.loader.unveil(this);
		});

		parentCarousel.data('imagesLoadedListenerAttached', true);
		parentCarousel.imagesLoaded().always(() => {
			const flkty = Flickity.data(parentCarousel[0]);
			flkty.reposition();
			flkty.resize();
		});
	}
};

$('.flickity-slider img').on('load', function (e) {
	resizeFlickityInstances(e.target);
});

window.lazySizes.init();
